import * as React from "react";
import IndexRouter from "./router/indexRouter";
import { BrowserRouter as Router } from "react-router-dom";
import "./App.css";
import "./layout2-theme.css";
import "./page-header-controls.css";

function App() {
  React.useEffect(() => {
    // Check if app is already installed and should not show the banner
    const isAppInstalled = () => {
      // Check 1: LocalStorage flag - set after successful installation
      const installedFlag = localStorage.getItem('pwaInstalled');
      if (installedFlag === 'true') return true;
      
      // Check 2: Standalone display mode - running as installed PWA
      const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
      if (isStandalone) return true;
      
      // Check 3: iOS standalone mode
      const isIOSStandalone = (window.navigator.standalone === true);
      if (isIOSStandalone) return true;
      
      // Check 4: Check related apps (Chrome Android)
      if (navigator.getInstalledRelatedApps) {
        return false; // Will be checked in beforeinstallprompt
      }
      
      return false;
    };

    const shouldShowInstallPrompt = () => {
      // Don't show if already installed
      if (isAppInstalled()) return false;
      
      // Don't show if user previously dismissed and hasn't reinstalled
      const dismissedAt = localStorage.getItem('pwaInstallDismissed');
      if (dismissedAt) {
        // Show again after 7 days
        const dismissedDate = new Date(dismissedAt);
        const daysSinceDismissed = (Date.now() - dismissedDate.getTime()) / (1000 * 60 * 60 * 24);
        if (daysSinceDismissed < 7) return false;
      }
      
      return true;
    };

    const handleBeforeInstallPrompt = async (e) => {
      // Don't show prompt if already installed or recently dismissed
      if (!shouldShowInstallPrompt()) {
        e.preventDefault();
        return;
      }

      const relatedApps = navigator.getInstalledRelatedApps
        ? await navigator.getInstalledRelatedApps()
        : [];
      const PWAisInstalled = relatedApps.length > 0;
      
      if (!PWAisInstalled) {
        let deferredPrompt = e;

        const installButton = document.createElement("button");
        installButton.textContent = "Continue To App";
        installButton.style.position = "fixed";
        installButton.style.top = "50%";
        installButton.style.padding = "10px 20px";
        installButton.style.color = "white";
        installButton.style.border = "none";
        installButton.style.borderRadius = "5px";
        installButton.style.cursor = "pointer";
        installButton.style.width = "100%";
        installButton.style.height = "50px";
        installButton.style.backgroundColor = "rgb(33, 130, 177)";
        installButton.style.fontSize = "14px";
        installButton.style.fontWeight = "bold";
        installButton.style.zIndex = "9999";

        installButton.addEventListener("click", () => {
          deferredPrompt.prompt();

          deferredPrompt.userChoice.then((choiceResult) => {
            if (choiceResult.outcome === "accepted") {
              console.log("App installed");
              // Mark as installed - won't show again
              localStorage.setItem('pwaInstalled', 'true');
            } else {
              console.log("App installation declined");
              // Remember when user dismissed - show again after 7 days
              localStorage.setItem('pwaInstallDismissed', new Date().toISOString());
            }

            installButton.style.display = "none";
          });
        });

        document.body.appendChild(installButton);
      }
    };

    // Listen for appinstalled event (fired after successful installation)
    const handleAppInstalled = () => {
      console.log('PWA installed successfully');
      localStorage.setItem('pwaInstalled', 'true');
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    window.addEventListener("appinstalled", handleAppInstalled);

    // Check on load if already in standalone mode
    if (isAppInstalled()) {
      console.log('App is already installed, skipping install prompt');
    }

    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
      window.removeEventListener("appinstalled", handleAppInstalled);
    };
  }, []);

  return (
    <React.Fragment>
      <Router>
        <IndexRouter />
      </Router>
    </React.Fragment>
  );
}

export default App;
